module.exports = __webpack_public_path__ + "img/watermark.dc3e84a0.png";